import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import ProductsWithUnitsSoldSplineChart from 'src/components/BeaconV2Components/ExperimentalLayout/Sales/ProductsWithUnitsSoldSplineChart';
import UnitsSoldProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/Sales/UnitsSold/UnitsSoldProductGrid';
import { BeaconSplineChartWithPromotionsWrapper } from 'src/components/BeaconV2Components/ExperimentalLayout/Prices/Promotions/BeaconSplineChartWithPromotions';

/**
 * Sales Units Sold Page
 */
const UnitsSoldPage = () => {
  const entityType = useMainEntityType();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <BeaconSplineChartWithPromotionsWrapper indexName="sales" fieldName="unitsSold" />
        <BeaconComparableSplineChart indexName="sales" fieldName="retailPrice" />
        <BeaconDropdownMetricColumnChart
          beaconChartWithLegendPropsBuilder={(props) => ({
            ...props,
            loadingComponent: <TopEntityChartV2Loading />
          })}
          indexName="sales"
          fieldName="unitsSold"
          dropdownOptions={[
            {
              id: 'subCategoryId',
              label: 'Subcategory'
            },
            {
              id: 'categoryId',
              label: 'Category'
            },
            {
              id: 'brandId',
              label: 'Brand'
            }
          ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
          titlePrefix="Units Sold by"
        />
        {entityType !== 'product' && <ProductsWithUnitsSoldSplineChart />}
        <UnitsSoldProductGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default UnitsSoldPage;
